export const GENERATE_HASH_KEY_API = "sse/api/generate-hash";
export const STREAM_SSE_EVENTS_API = "sse/api/stream-events";

export const MAX_RETRIES = 3;

export const EVENT_TYPES = {
  NOTIFICATION: 1,
  REFRESH: 2,
  REFRESH_OR_NOTIFICATION: 3,
};

export const EVENT_SOURCES = {
  NEW_WHATSAPP: 1,
  NEW_EMAIL: 2,
  AI_PAGE_READY: 3,
};
